/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upgrade_Alert_LaterInputs */

const en_mobile_upgrade_alert_later = /** @type {(inputs: Mobile_Upgrade_Alert_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const es_mobile_upgrade_alert_later = /** @type {(inputs: Mobile_Upgrade_Alert_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más tarde`)
};

/**
* | output |
* | --- |
* | "Later" |
*
* @param {Mobile_Upgrade_Alert_LaterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upgrade_alert_later = /** @type {((inputs?: Mobile_Upgrade_Alert_LaterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upgrade_Alert_LaterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upgrade_alert_later(inputs)
	return en_mobile_upgrade_alert_later(inputs)
});